import React from "react";

const CartContext = React.createContext(null);

export default CartContext;
